// dev/stg đặt REACT_APP_CAPTCHA_REQUIRED=false: widget vẫn hiện nhưng không bắt tick mới submit được.
// Dùng cờ riêng thay vì để trống key, vì Nx còn nạp .env ở gốc repo (có key) vào mọi bản build.
// Production luôn bắt tick, thiếu key thì báo lỗi ngay chứ không lặng lẽ mở form không có captcha.
const isProduction = process.env.REACT_APP_ENV === 'production';

export const CAPTCHA_SITE_KEY = process.env.REACT_APP_LANDING_PAGE_CAPTCHA_SITE_KEY || '';

export const isCaptchaRequired = isProduction || process.env.REACT_APP_CAPTCHA_REQUIRED !== 'false';

if (isProduction && !CAPTCHA_SITE_KEY) {
  throw new Error('Thiếu REACT_APP_LANDING_PAGE_CAPTCHA_SITE_KEY cho production');
}
